var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('content-loader',{attrs:{"width":"1500","height":"400","view-box":"0 0 1500 400","primary-color":"#f3f3f3","secondary-color":"#ecebeb"}},[_c('rect',{attrs:{"x":"21","y":"38","rx":"5","ry":"5","width":"1500","height":"180"}})])}
var staticRenderFns = []

export { render, staticRenderFns }